export const MAX_RANGE_MONTHS = 3;

export const toInputDate = (date: Date) => date.toISOString().slice(0, 10);

export const firstOfThisMonth = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};

/** Earliest start date still within the allowed window for a given end date. */
export const minStartFor = (endDate: string) => {
  const end = new Date(endDate);
  if (Number.isNaN(end.getTime())) return toInputDate(firstOfThisMonth());
  const floor = new Date(end);
  floor.setMonth(floor.getMonth() - MAX_RANGE_MONTHS);
  return toInputDate(floor);
};

/** End date that is still within the allowed window for a given start date. */
export const maxEndFor = (startDate: string) => {
  const start = new Date(startDate);
  if (Number.isNaN(start.getTime())) return toInputDate(new Date());
  const capped = new Date(start);
  capped.setMonth(capped.getMonth() + MAX_RANGE_MONTHS);
  const today = new Date();
  return toInputDate(capped < today ? capped : today);
};

export const formatAuditDateTime = (value: any) =>
  value
    ? new Date(value).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';
